<div class="flex flex-row gap-2 md:gap-4 logo-container">

  <mat-divider class="logo-divider" [vertical]="true"></mat-divider>

  <div class="flex flex-row justify-start items-center gap-2 md:gap-4 bank-logo-image">
    @if (showLogo()) {
      <img class="logo-img" (error)="setLogoInvalid()" [src]="getLogoUrl()" role="link" aria-hidden="false" aria-label="Bank Logo." alt="Bank Logo"/>
    }

    @if (showBankName()) {
      <p class="header-bank-name heading-sm-semibold color-content-subtle">{{bankName}}</p>
    }
  </div>
</div>
